interface StepIndicatorProps {
  currentStep: number;
  totalSteps: number;
}

/**
 * ステップインジケーター
 * 進行度のドットインジケーターとプログレスバー
 */
export function StepIndicator({ currentStep, totalSteps }: StepIndicatorProps) {
  return (
    <div className="mb-6">
      <div className="flex items-center justify-between mb-2">
        <div className="text-[#0052FF] text-sm font-semibold">
          ステップ {currentStep + 1} / {totalSteps}
        </div>
        <div className="flex items-center gap-2">
          {Array.from({ length: totalSteps }, (_, stepIdx) => (
            <div
              key={stepIdx}
              className={`w-2 h-2 rounded-full transition-all ${
                stepIdx === currentStep
                  ? 'w-6 bg-[#0052FF]'
                  : stepIdx < currentStep
                  ? 'bg-[#0052FF]'
                  : 'bg-[#E5E7EB]'
              }`}
            />
          ))}
        </div>
      </div>
      <div className="w-full bg-[#E5E7EB] h-1.5 rounded-full overflow-hidden">
        <div
          className="h-full bg-[#0052FF] transition-all duration-300 ease-in-out"
          style={{ width: `${((currentStep + 1) / totalSteps) * 100}%` }}
        />
      </div>
    </div>
  );
}
